import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({ apidata, columns, searchBy }) {
  const [dataFilter, setDataFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [hubFilter, setHubFilter] = useState("");
  const [clientFilter, setClientFilter] = useState("");
  const [deliveryDateFilter, setDeliveryDateFilter] = useState("");

  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  useEffect(() => {
    let filtered = apidata;

    // Status Filter
    if (statusFilter) {
      filtered = filtered.filter(
        (item) =>
          item.order_status &&
          item.order_status.toLowerCase() === statusFilter.toLowerCase()
      );
    }

    // Hub Filter
    if (hubFilter) {
      filtered = filtered.filter(
        (item) =>
          item.hub_id &&
          item.hub_id.name.toLowerCase().includes(hubFilter.toLowerCase())
      );
    }

    // Client Filter
    if (clientFilter) {
      filtered = filtered.filter(
        (item) =>
          item.client_id &&
          item.client_id.name.toLowerCase().includes(clientFilter.toLowerCase())
      );
    }

    // Delivery Date Filter
    if (deliveryDateFilter) {
      filtered = filtered.filter((item) => {
        if (!item.delivery_date) return false;
        const itemDate = new Date(item.delivery_date)
          .toISOString()
          .split("T")[0];
        return itemDate === deliveryDateFilter;
      });
    }

    // Search Filter
    if (dataFilter) {
      filtered = filtered.filter((item) => {
        if (!item[searchBy]) return false;

        let valueToFilter = "";

        if (searchBy === "vehicle_id" && item.vehicle_id) {
          valueToFilter = item.vehicle_id.numberplate || "";
        } else {
          valueToFilter = item[searchBy] ? item[searchBy].toString() : "";
        }

        return valueToFilter.toLowerCase().includes(dataFilter.toLowerCase());
      });
    }

    setFilteredData(filtered);
  }, [
    dataFilter,
    statusFilter,
    hubFilter,
    clientFilter,
    deliveryDateFilter,
    apidata,
    searchBy,
  ]);

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setStatusFilter("");
    setHubFilter("");
    setClientFilter("");
    setDeliveryDateFilter("");
    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
        />
      ) : (
        <div className="row justify-content-start">
          <div className="col-12">
            <p>No results found.</p>
          </div>
        </div>
      )}

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        apidata={apidata}
        hubFilter={hubFilter}
        setHubFilter={setHubFilter}
        clientFilter={clientFilter}
        setClientFilter={setClientFilter}
        deliveryDateFilter={deliveryDateFilter}
        setDeliveryDateFilter={setDeliveryDateFilter}
      />
    </div>
  );
}
